module.exports = {"label":"Geburtsdatum","placeholder":"Gib dein Geburtsdatum ein","dayFormat":"TT","monthFormat":"MM","yearFormat":"JJ","age_requirement":"Du musst mindestens {{age}} Jahre alt sein.","accept_terms":"Durch das Anklicken der Schaltfläche stimme ich den","accept_terms_link":"Nutzungsbedingungen zu","check_format":"Bitte nachprüfen","day":"Tag","month":"Monat","year":"Jahr"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/birthdate.json
// module id = 473
// module chunks = 248 1706